import styled from "styled-components";

export const OptInWinHighlightFormattedMoneyBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: baseline;
    font-size: 1rem;
    white-space: nowrap;
`